import React, { useState, useEffect } from "react";

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import img from '../Assets/automotive-technology-solutions-connectivity-banner-1.jpg'
import img2 from '../Assets/Mask group.png'
import img3 from '../Assets/Group 184.png'
import img4 from '../Assets/Group 11.png'
import heading from '../Assets/heading5.png'
import icon from '../Assets/ai icon.png'
import icon2 from '../Assets/ev.png'
import icon3 from '../Assets/ISO26262 & Cyber Security.avif'
import icon4 from '../Assets/Software Defined Vehicles.png'
function AutomotiveSolutions() {
  return (
    <>
    <Navbar/>
     <div className="banner-heading">
          <img src={heading}/>
        </div>
        <div className='silicon'>
  <div className='silicon-left'>
<p>Driving Innovation, Powering Performance: Your Trusted Partner for Automotive Electronics </p>

<h3>Automotive Solutions</h3>
<br/>
<br/>
<h4>Semicave is a global engineering technology partner with strong industry experience in semiconductor design and automotive solutions. Our Automotive business unit has a strong customer focus and provides engineering services & solutions for top Automotive Tier-1 suppliers and OEMs
As a value partner in the automotive solutions industry, we constantly leverage the software and hardware integration expertise to provide end-to-end turnkey solutions for our customers. With deep automotive electronics capabilities, we consistently deliver to our customer requirements using established industry processes and standards. 
</h4>

        </div>
          <div className='silicon-right'>
<img src={img}/>
        </div>
        </div>
         <div className="services-heading">
          <p>Mastering Complexity: Elevating Automotive Engineering with Expert Integration
</p>
          <h3>
        Our Core Competencies
          </h3>
        </div>
      <div className="ai-boxs">
<div className="ai-box">
<img src={icon}/>
<h3>Verification & Validation  </h3>
<p>Unit Testing, Integration Testing </p>
</div>
<div className="ai-box">
<img src={icon2}/>

<h3>EV & Powertrain  </h3>
<p>Power electronics, Control SW, Testing & Validation </p>
</div>
<div className="ai-box">
<img src={icon3}/>

<h3>ISO26262 & Cyber Security  </h3>
<p>Steering. Braking, Suspension & Damping</p>
</div>
<div className="ai-box">
<img src={icon4}/>

<h3>Software Defined Vehicles  </h3>
<p>Body Domain Controllers, Security, Safety, Lighting, HVAC</p>
</div>
</div>
     

       <div className="our-expertise">
     <h3>Our Focus Areas</h3>
<br/>
<br/>
<div className="Embedded-boxs">
<div className="Embedded-box">
<div className="Embedded-img Embedded-img6">
<div className="overlay3">

<h5>ADAS & Autonomous</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">
<h4>Integration of Computer Vision</h4>
<p><i class="bi bi-arrow-right-short"></i>Perception</p>
<p><i class="bi bi-arrow-right-short"></i>Localization</p>
<p><i class="bi bi-arrow-right-short"></i>Vehicle Control</p>
<p><i class="bi bi-arrow-right-short"></i>AI/ML/DL</p>
<p><i class="bi bi-arrow-right-short"></i>Assisted Driving</p>
<p><i class="bi bi-arrow-right-short"></i>Connected Features</p>



</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img7">
<div className="overlay3">

<h5>Connected Cars</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">
<h4>V2X Connectivity & Telematics</h4>
<p><i class="bi bi-arrow-right-short"></i>Digital Cockpit
</p>
<p><i class="bi bi-arrow-right-short"></i>Telematics
</p>
<p><i class="bi bi-arrow-right-short"></i>V2X, App Dev
</p>
<p><i class="bi bi-arrow-right-short"></i>V2X Integration
</p>
<p><i class="bi bi-arrow-right-short"></i>5G Integration
</p>
<p><i class="bi bi-arrow-right-short"></i>Extended Cars
</p>

</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img8">
<div className="overlay3">

<h5>Infotainment System</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">
<h4>Digital Cockpit / HMI & IVI</h4>
<p><i class="bi bi-arrow-right-short"></i>HMI & Application Software</p>
<p><i class="bi bi-arrow-right-short"></i>Hardware and Mechanical</p>
<p><i class="bi bi-arrow-right-short"></i>Testing & Validation</p>
<p><i class="bi bi-arrow-right-short"></i>Vehicle Interfacing</p>




</div>


</div>
<div className="Embedded-box">
<div className="Embedded-img Embedded-img9">
<div className="overlay3">

<h5>EV & Powertrain</h5>
</div>
</div>
<br/>
<div className="Embedded-img-text">
<h4>Architecture & Charging Tech</h4>
<p><i class="bi bi-arrow-right-short"></i>Battery Management System</p>
<p><i class="bi bi-arrow-right-short"></i>Powertrain Architecture</p>
<p><i class="bi bi-arrow-right-short"></i>Charging Electronics</p>
<p><i class="bi bi-arrow-right-short"></i>Engine Management</p>




</div>


</div>
</div>
     </div>
    <Footer/>

</>
  )
}

export default AutomotiveSolutions